<template>
  <CFooter :fixed="false">
    <div>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
